import { Link } from "react-router-dom";

/**
 * Shared top nav for public (non-authenticated) pages.
 * Matches the sticky nav on Landing.jsx — keep in sync.
 */
export default function PublicNav() {
  return (
    <nav className="border-b border-[var(--border)] px-6 py-4 flex items-center justify-between sticky top-0 bg-[var(--bg-page)]/95 backdrop-blur z-40">
      <Link to="/" className="font-section text-lg tracking-widest text-white hover:txt-accent transition-colors">
        ALGOFORGE
      </Link>
      <div className="flex items-center gap-5 text-xs font-section tracking-wider txt-muted">
        <Link to="/learn"   className="hover:text-white transition-colors hidden sm:block">LEARN</Link>
        <Link to="/blog"    className="hover:text-white transition-colors hidden sm:block">BLOG</Link>
        <Link to="/faq"     className="hover:text-white transition-colors hidden sm:block">FAQ</Link>
        <Link to="/pricing" className="hover:text-white transition-colors hidden sm:block">PRICING</Link>
        <Link to="/login"   className="hover:text-white transition-colors">LOGIN</Link>
        <Link
          to="/register"
          className="px-3 py-1.5 border border-[var(--accent)] text-[var(--accent)] hover:bg-[var(--accent-muted)] transition-colors"
        >
          START FREE
        </Link>
      </div>
    </nav>
  );
}
